import * as React from 'react'

function KiteAboutUsIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={1813.891} height={830.378} viewBox="0 0 1813.891 830.378" {...props}>
      <g
        data-name="Group 6317"
        transform="translate(-58.61 -2539.636) translate(1379.414 2539.636)"
        fill="none"
        stroke="#263238"
        strokeLinejoin="round"
        strokeWidth={1}
      >
        <path
          data-name="Path 1347"
          d="M449.999 186.272h42.588c0-34.69-31.905-24.058-31.905-24.058s4.979-24.718-29.052-24.718c1.953-34.858-53.944-54.494-84.3-29.108"
        />
        <path
          data-name="Path 17169"
          d="M328.077 0c0 40.347-42.053 27.981-42.053 27.981s6.562 28.749-38.292 28.749c2.574 40.542-71.1 63.38-111.112 33.855"
        />
        <path
          data-name="Path 17167"
          d="M264.513 186.271c0-21.423 19.7-14.857 19.7-14.857s-3.075-15.265 17.941-15.265c-1.367-24.407 43.189-36.73 58.465-10.272"
        />
        <path
          data-name="Path 17168"
          d="M0 21.229c0 24.916 25.97 17.28 25.97 17.28s-4.05 17.754 23.65 17.754c-1.8 28.387 56.926 42.719 77.06 11.947"
        />
        <path data-name="Line 244" transform="translate(414.773 186.272)" d="M0 0L19.036 0" />
      </g>
      <g data-name="Group 6316" transform="translate(-58.61 -2539.636) rotate(-29 5146.68 1065.932)">
        <path
          data-name="Path 2080"
          d="M87.091 108.352c.027-.053-11.106-13.9-17.408-20.175a72.4 72.4 0 00-14.218-11.252c-3.905-2.29-7.758-5.163-10.114-9.134s-3.1-12.219 1.072-15.436c4.58-3.548 11.914-3.362 17.315-3.177a166.708 166.708 0 0120.188 2.264c6.42.993 12.841 2.145 19.328 2.74 4.66.437 9.995.9 14.482-.808a9.028 9.028 0 003.892-2.648 10.588 10.588 0 001.324-2.5 9.081 9.081 0 00.278-1.152c.318-.927.6 3.68 0-.41a28.62 28.62 0 00-3.693-10.974c-5.428-9-15.33-14.562-24.623-18.758-13.529-6.105-29.03-11.916-44.056-11.824-14.284.159-28.872 5.414-39.039 15.647A40.125 40.125 0 001.52 38.045a35.174 35.174 0 00-1.006 4.832 28.994 28.994 0 00-.291 3.032c.093-2.714.146.741.331 2.025a45.483 45.483 0 003.375 11.517c.635 1.483-.622 3.746 0 5.2-6.963-16.334-4.884-36.204 7.943-49.085a54.276 54.276 0 0127.8-14.482C52.659-1.564 64.825.978 77.2 5.055c16.1 5.3 38.827 12.894 44.837 30.792a36.247 36.247 0 011.324 16.071c-1.244 7.771-10.326 7.943-16.561 7.7-12.166-.583-24.107-3.6-36.219-4.792-6.815-.671-25.881-3.026-26.845 7.537v-4.58c.45 4.448 3.76 8.075 7.1 10.776 4.978 3.971 10.59 6.725 15.436 11.094a163.312 163.312 0 0120.85 23.458c.847 1.138 0 5.189 0 5.189z"
          fill="#263238"
          opacity={0.8}
        />
        <path
          data-name="Path 2081"
          d="M72.95 103.638s-8.721-18.606-14.893-26.82c-2.78-3.76-8.472-7.943-9.015-12.814-.146-1.231-.53-4.17.318-5.3 1.39-1.761 6.037-1.191 7.943-1.178 13.781.106 27.482 1.959 41.29 1.324 7.943-.371 22.5-1.138 23.365-11.755v2.648c0-4.779-2.767-11.332-4.594-15.806a51.5 51.5 0 00-11.451-17.607A38.7 38.7 0 0085.248 5.968C75.041 4.26 64.9 6.749 54.8 7.927c-8.9 1.032-17.884 1.615-26.7 3.243-6.117 1.139-12.656 2.83-17.356 7.149S3.887 29.664 3.966 36c.159 11.239 2.489 22.571 3.72 33.744S10.1 92.836.259 100.395c.808-.622-.874-4.527 0-5.189a19.857 19.857 0 006.619-7.943 21.568 21.568 0 001.192-4.819 15.325 15.325 0 00.146-1.734c-.093 2.012 0 .516 0 0a144.459 144.459 0 00-.41-4.766C6.481 63.05 3.979 50.17 3.834 37.17c-.066-8.088 0-17.064 6.037-23.286 6.473-6.725 17.051-7.943 25.814-9.108 6.354-.794 12.735-1.324 19.089-2.1C62.068 1.824 69.336.2 76.736.024a40.416 40.416 0 0130.564 12.43c6.315 6.765 10.352 15.409 12.788 24.265 1.483 5.388 3.429 13.04 1.324 18.533-7.135 18.2-71.592 1.244-72.227 9.412v-5.2c.2 1.814 1.92 3.429 3.018 4.739 2.462 2.926 4.938 5.812 7.149 8.949 5.626 7.767 11.99 22.441 15.479 31.375z"
          transform="translate(13.942 1.775)"
          fill="#eceff1"
        />
        <path
          data-name="Path 2072"
          d="M198.435 159.298l-53.561-25.788-.04-.013-35.094-16.892-.026-.013-2.344-1.139h-.013l-7.863-3.786h-.013l-1.39-.675-5.137-2.476-.927-.45-3.534-1.707-.715-.331-1.562-.755.185.927 17.475 88.43 14.019 5.083 24.57 8.9.079.04 26.291 9.518.066.04 18.1 6.553 2.356-13.529h0l.093-.424 3.535-20.294.013-.066 3.905-22.359z"
          fill="#fff"
          stroke="#263238"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1}
        />
        <path
          data-name="Line 256"
          transform="translate(103.875 159.297)"
          fill="#fff"
          stroke="#263238"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1}
          d="M0 35.332L94.56 0"
        />
        <path
          data-name="Line 257"
          transform="translate(86.217 105.273)"
          fill="#eceff1"
          stroke="#263238"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1}
          d="M100.781 119.487L0 0"
        />
      </g>
      <path
        data-name="Path 17174"
        d="M342.355 2713.776c-109.6-35.33-186.239-28.518-233.4-2.379-20.208 11.2-35.086 25.929-45.062 42.664-23.066 38.7 46.349 133.787 46.349 133.787l27.087 29.828s115.643 8.887 199.065-35.908c115.812-74.95 238.188-115.384 331.008-117.375 45.234-.97 83.557 7.081 111.116 24.729 42.589 27.271 58.556 77.831 32.187 153.254-78.029 223.186-385.228 447.085-131.308 361.84 129.474-46.482 116.756 42.524 116.087 65.783"
        fill="none"
        stroke="#263238"
        strokeLinejoin="round"
        strokeWidth={1}
        opacity={0.3}
        transform="translate(-58.61 -2539.636)"
      />
    </svg>
  )
}

export default KiteAboutUsIcon
